import { createStore, applyMiddleware, compose } from "redux";
import reducers from "./reducers";
import { createLogger } from "redux-logger";
import createSagaMiddleware from 'redux-saga'
import rootSaga from "../sagas";
import { routerMiddleware } from "connected-react-router";
import history from "../lib/history";
import { composeWithDevTools } from "redux-devtools-extension";
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const persistConfig = {
  key: 'root',
  storage,
  blacklist: [''],
  whitelist: ['Auth', 'paymentCart'],
}


const sagaMiddleware = createSagaMiddleware()

const logger = createLogger({
  predicate: (getState, action) => !!process.env.NODE_ENV
});

const connectedRouterMiddleware = routerMiddleware(history);
const persistedReducer = persistReducer(persistConfig, reducers)
const initialstore = {};
let middlewares = [
  logger,
  sagaMiddleware,
];
if (!process.env.IS_SERVER) {
  middlewares.push(connectedRouterMiddleware);
}
const enhancers = [composeWithDevTools(applyMiddleware(...middlewares))];
const store = createStore(persistedReducer,
  initialstore,
  compose(
    ...enhancers
  ));
sagaMiddleware.run(rootSaga);
store.asyncReducers = {};
const persistor = persistStore(store);

export { store, persistor };

